import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 15 * 60;
export function UrgencyBar() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;
  return <div className="w-full bg-coral text-cream" data-id="element-210" data-mp="2yx80xi5cdbfy">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-2 px-4 py-2.5 text-center text-[11px] font-semibold uppercase tracking-[0.16em] sm:text-xs" data-id="element-211" data-mp="2u3naqc9zplrb">
        <HourglassIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-212" data-mp="2k6r1238cutl6" />
        <span data-id="element-213" data-mp="2k4nykjq0n7zk">La oferta termina en</span>
        <span aria-live="off" className="tabular-nums text-base font-bold tracking-normal" data-id="element-214" data-mp="2f7nv8gkjwjc5">
          {String(minutes).padStart(2, '0')}
          <span className="mx-0.5 opacity-60" data-id="element-215" data-mp="2b6m2mil535j5">:</span>
          {String(seconds).padStart(2, '0')}
        </span>
      </div>
    </div>;
}